export default "__VITE_ASSET__QlR_bV8y__"